<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>消息</el-breadcrumb-item>
          <el-breadcrumb-item>收件箱</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-collapse v-show="isActive">
            <el-row class="search-row">
              <el-col :span="6" class="display-row">
                <div class="query-title">订单编号:</div>
                <div class="flex1">
                  <el-input placeholder="请输入内容" clearable v-model="queryInfo.orderId" size="small" v-on:click.self="searchList"
                    @keyup.enter.native="searchList">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="6" class="display-row">
                <div class="query-title">用户ID:</div>
                <div class="flex1">
                  <el-input placeholder="请输入内容" clearable v-model="queryInfo.createUserName" size="small"
                    @keyup.enter.native="searchList">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="6" class="display-row">
                <div class="query-title">类型:</div>
                <div class="flex1">
                  <el-select v-model="queryInfo.messageType" placeholder="请选择" size="small" clearable>
                    <el-option v-for="item in messageTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="6" class="display-row">
                <div class="query-title">发送开始日:</div>
                <div class="flex1">
                  <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" placeholder="选择日期">
                  </el-date-picker>
                </div>
              </el-col>
            </el-row>
            <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">发送结束日:</div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
        </el-collapse>
        <el-row class="search-row">
          <!-- <el-col :span="6" class="display-row">
            <div class="query-title">消息状态:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.replyFlag" placeholder="请选择" size="small" clearable>
                <el-option
                    v-for="item in replyStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col> -->
          <el-col :span="18" class="display-row">
            <div class="search-btn-container search-btn-container-status">
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 3}" @click="changeTab(3)">全部
              </el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 0}" @click="changeTab(0)">未读<span
                  class="lx-red">({{messageCount.notReadCount}})</span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 1}" @click="changeTab(1)">已读<span
                  class="lx-red"></span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 2}" @click="changeTab(2)">已回复<span
                  class="lx-red"></span></el-button>

            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="search-btn-container">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList()">搜索</el-button>
              <el-button class="search-btn btn-blue" @click="readAll">全部已读</el-button>
              <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt="" @click="isActive = !isActive" >展开</el-button>
              <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt="" @click="isActive = !isActive" >收起</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="messageList" border
          height="550">
          <el-table-column align="center" type="index" label="序号" width="40"></el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template v-slot="scope">
              <div class="btn-row">
                <el-button class="list-btn btn-green" @click="reply(scope.row)"
                  v-if="btnReplyFlag == scope.row.replyFlag && scope.row.createUserName != 'system'">
                  回复
                </el-button>
              </div>
              <div class="btn-row">
                <el-button class="list-btn btn-blue" @click="read(scope.row)" v-if="btnReadFlag == scope.row.isRead">
                  已读
                </el-button>
              </div>
              <div class="btn-row">
                <el-button class="list-btn btn-blue" @click="handleDetail(scope.row)">
                  详情
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="replyFlag" :index="indexMethod" sortable label="消息状态" align="center">
            <template v-slot="scope">
              {{ replyStatusShow(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column width="100" prop="replyPicture" label="图片">
            <template slot-scope="scope">
              <div v-for="item in getFileList(scope.row.replyPicture)" :key="item">
                <img @click="imgclick(item,true)" v-if="item&&item.length>0"
                     :src="item" alt="" class="list-image more-image" >
                <img v-else src="../../assets/images/default.png" alt="" class="list-image">
              </div>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="messageType" align="center" label="类型">
            <template v-slot="scope">
              {{ typeDetailShow(scope.row.messageType) }}
            </template>
          </el-table-column>
          <el-table-column width="200" prop="orderId" align="center" label="订单编号">
            <template v-slot="scope">
              <el-link @click="toOrderDetail(scope.row)" :underline="false">{{scope.row.orderId}}</el-link>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="createUserName" label="用户ID">
            <template v-slot="scope">
              {{scope.row.createUserName === 'system'?"":scope.row.createUserName}}
            </template>
          </el-table-column>
          <el-table-column width="160" prop="createTime" sortable :index="indexMethod" align="center" label="发送日">
            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column width="200" prop="remindingTitle" align="center" label="标题">
          </el-table-column>
          <el-table-column prop="remindingContent" label="内容">
            <template v-slot="scope">
              <div v-html="scope.row.remindingContent"></div>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" width="200" label="附件">
            <template v-slot="scope">
            <span v-for="item in getAttachment(scope.row.attachment)" :key="item">
              <a target="_blank" :href="item.url">{{item.name}}</a><br/>
            </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </table-con>

    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image">
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
    <!-- 详情 -->
    <el-dialog title="信息详情" :visible.sync="detailFlag" width="1400px">
      <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="firstList" border>
        <el-table-column label="操作" align="center" width="120">
          <template v-slot="scope">
            <div class="btn-row">
              <el-button class="list-btn btn-green" @click="reply(scope.row)"
                v-if="btnReplyFlag == scope.row.replyFlag && scope.row.createUserName != 'system'">
                回复
              </el-button>
            </div>
            <div class="btn-row">
              <el-button class="list-btn btn-blue" @click="read(scope.row)" v-if="btnReadFlag == scope.row.isRead">
                已读
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="100" prop="replyFlag" :index="indexMethod" sortable label="消息状态" align="center">
          <template v-slot="scope">
            {{ replyStatusShow(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="replyPicture" width="100" label="图片">
          <template slot-scope="scope">
            <div v-for="item in getFileList(scope.row.replyPicture)" :key="item">
              <img @click="imgclick(item,true)" v-if="item&&item.length>0"
                   :src="item" alt="" class="list-image more-image" >
              <img v-else src="../../assets/images/default.png" alt="" class="list-image">
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="messageType" align="center" label="类型">
          <template v-slot="scope">
            {{ typeDetailShow(scope.row.messageType) }}
          </template>
        </el-table-column>
        <el-table-column prop="orderId" align="center" label="订单编号">
          <template v-slot="scope">
            <el-link @click="toOrderDetail(scope.row)" :underline="false">{{scope.row.orderId}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" label="用户ID">
          <template v-slot="scope">
            {{scope.row.createUserName === 'system'?"":scope.row.createUserName}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" width="160"  sortable :index="indexMethod" align="center" label="发送日">
          <template v-slot="scope">
            {{ scope.row.createTime | dateFormatToSecond }}
          </template>
        </el-table-column>
        <el-table-column prop="remindingTitle" align="center" label="标题">
        </el-table-column>
        <el-table-column width="200" prop="remindingContent" label="内容">
          <template v-slot="scope">
            <div v-html="scope.row.remindingContent"></div>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" width="200" label="附件">
          <template v-slot="scope">
            <span v-for="item in getAttachment(scope.row.attachment)" :key="item">
              <a target="_blank" :href="item.url">{{item.name}}</a><br/>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="title">历史对话</div>
      <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="historyMessageList" border
        height="550px">
        <el-table-column label="发件人" prop="sender" align="center">
          <template v-slot="scope">
            <div v-if="scope.row.sender==1">平台</div>
            <div v-if="scope.row.sender==0">客户</div>
          </template>
        </el-table-column>
        <el-table-column prop="replyFlag" :index="indexMethod" sortable label="消息状态" align="center">
          <template v-slot="scope">
            {{ replyStatusShow(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="replyPicture" width="100" label="图片">
          <template slot-scope="scope">
            <div v-for="item in getFileList(scope.row.replyPicture)" :key="item">
              <img @click="imgclick(item,true)" v-if="item&&item.length>0"
                   :src="item" alt="" class="list-image more-image" >
              <img v-else src="../../assets/images/default.png" alt="" class="list-image">
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="messageType" align="center" label="类型">
          <template v-slot="scope">
            {{ typeDetailShow(scope.row.messageType) }}
          </template>
        </el-table-column>
        <el-table-column prop="orderId" align="center" label="订单编号">
          <template v-slot="scope">
            <el-link @click="toOrderDetail(scope.row)" :underline="false">{{scope.row.orderId}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" label="用户ID">
          <template v-slot="scope">
            {{scope.row.createUserName === 'system'?"":scope.row.createUserName}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" width="160" sortable :index="indexMethod" align="center" label="发送日">
          <template v-slot="scope">
            {{ scope.row.createTime | dateFormatToSecond }}
          </template>
        </el-table-column>
        <el-table-column width="100" prop="remindingTitle" align="center" label="标题">
        </el-table-column>
        <el-table-column width="200" prop="remindingContent" label="内容">
          <template v-slot="scope">
            <div v-html="scope.row.remindingContent"></div>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" width="200" label="附件">
          <template v-slot="scope">
            <span v-for="item in getAttachment(scope.row.attachment)" :key="item">
              <a target="_blank" :href="item.url">{{item.name}}</a><br/>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align:right;margin-top:15px">
        <el-button class="form-btn btn-blue" @click="detailFlag=false">确定</el-button>
      </div>
    </el-dialog>

    <MessageTip title="回复" :visiable.sync="isVisiable" :userName="replyMessageInfo.createUserName" :id="replyMessageInfo.id"
      :messageType="replyMessageInfo.messageType == '1' ? '订单消息' : '其他消息'" :orderNo="replyMessageInfo.orderId"
      httpUrl="cms/inBox/reply" @confirm="onConfirmMsg"></MessageTip>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'
import MessageTip from '@/components/MessageTip/index'

export default {
  components: { tableCon, MessageTip },
  data () {
    return {
      isActive:false,
      curIndex: '', // 默认选中第0个
      visible: false,
      imgurl: '',
      hideUploadEdit: false,
      detailFlag: false,
      firstList: [],
      historyMessageList: [],
      listObj: [],
      imgDataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
        timeStamp: ''
      },
      fileList: [],
      btnReplyFlag: 0,
      btnReadFlag: 0,
      replyInfo: {
        remindingContent: '',
        remindingTitle: '',
        replyPicture: '',
        imgFileList: [],
        imgFileListStr: '',
        attachment:'',
      },
      rules: {
        remindingTitle: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        remindingContent: [
          { required: true, message: '请输入回复内容', trigger: 'blur' }
        ]
      },
      queryInfo: {
        createUserName: '',
        orderId: '',
        messageType: '',
        createTimeStart: '',
        createTimeEnd: '',
        replyFlag: '',
        pageSize: 10,
        pageNum: 1
      },
      messageCount: {
        total: 0,
        replyCount: 0,
        notReplyCount: 0
      },
      // dateRangeValue: [],
      replyMessageInfo: {},  //回复页面显示表格所在行内容
      splitDialogVisible: false,
      dialogVisible: false,
      messageTypeOptions: [
        {
          value: '1',
          label: '订单消息'
        }, {
          value: '2',
          label: '其他消息'
        }
      ],
      replyStatusOptions: [
        {
          value: '0',
          label: '未回复'
        }, {
          value: '1',
          label: '已回复'
        }
      ],
      id: "",
      messageList: [],
      dialogFormVisible: false,
      replyDialogVisible: false,
      total: 0,
      isVisiable: false, // 消息提醒弹框
    }
  },
  methods: {
    changeTab (index) {
      this.curIndex = index
      this.searchList()
    },
    async handleDetail (row) {
      this.id = row.id
      const { data: res } = await this.$http.get('cmUser/message/queryMessageInfo/' + row.id);
      this.historyMessageList = res.data
      let arr = []
      res.data.forEach(item => {
        if (item.id == this.id) {
          arr.push(item)
        }
      })
      this.firstList = arr
      this.detailFlag = true
    },
    getFileList (str) {
      if (str != null){
        return str.split(",");
      }
      return []
    },
    getAttachment (str){
      if (str != null && str.length > 0){
        return JSON.parse(str);
      }
      return []
    },
    imgclick (url, visible) {
      this.visible = true
      this.imgurl = url
    },
    showImgDialog (index) {
      this.imgDialogVisible = true;
    },
    handleCurrentChange (newPage) {    //分页
      this.queryInfo.pageNum = newPage;
      this.getMessageCount();
      this.getMessageList();
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getMessageCount();
      this.getMessageList();
    },
    orderDateRange () {   //搜索时间

    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },

    clearReplyForm () {   //回复弹窗的取消按钮
      this.initReplyForm();
      this.replyDialogVisible = false;
    },
    initReplyForm () {   //初始化回复弹窗的内容
      this.replyInfo = {
        remindingContent: '',
        remindingTitle: '',
        replyPicture: '',
        attachment: '',
      };
    },

    searchList () {    //查询
      if (this.curIndex == 0) {
        this.queryInfo.isRead = 0;
        this.queryInfo.replyFlag = '';
      }
      else if (this.curIndex == 1) {
        this.queryInfo.isRead = 1;
        this.queryInfo.replyFlag = '';
      }
      else if (this.curIndex == 2) {
        this.queryInfo.isRead = '';
        this.queryInfo.replyFlag = 1;
      } else if (this.curIndex == 3) {
        this.queryInfo.isRead = '';
        this.queryInfo.replyFlag = '';
      }

      this.queryInfo.pageNum = 1;
      this.getMessageCount();
      this.getMessageList();
    },
    async getMessageList () {   //获取信息列表
      const { data: res } = await this.$http.get('cms/inBox/list', { params: this.queryInfo });
      this.messageList = res.data.list;
      this.total = res.data.total;
    },
    async getMessageCount () {   //获取信息列表
      const { data: res } = await this.$http.get('cms/inBox/messageCount', { params: this.queryInfo });
      this.messageCount = res.data;
    },
    queryInfoClear () {    //清空
      this.curIndex = ''
      this.queryInfo = {
        createTimeStart: '',
        createTimeEnd: '',
        orderId: '',
        userName: '',
        pageSize: 10,
        pageNum: 1
      }
      // this.dateRangeValue = [];
    },
    typeDetailShow (status) {
      switch (status) {
        case '1':
          return '订单消息'
          break;
        case '2':
          return '其他消息'
          break;
      }
    },
    replyStatusShow (row) {
      if (row.createUserName == "system") {
        return "-";
      }
      switch (row.replyFlag) {
        case '1':
          return '已回复'
          break;
        default:
          return '未回复'
          break;
      }
    },
    async read (row) {    //已读
      var url = 'cms/inBox/read';
      this.id = row.id
      const { data: res } = await this.$http.post(url, { id: row.id });
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
      this.getMessageCount();
      this.getMessageList();
      this.btnReadFlag == row.isRead;
      if (this.detailFlag) {
        const { data: res } = await this.$http.get('cmUser/message/queryMessageInfo/' + this.id);
        this.historyMessageList = res.data
        let arr = []
        res.data.forEach(item => {
          if (item.id == this.id) {
            arr.push(item)
          }
        })
        this.firstList = arr
      }
    },
    //全部已读
    async readAll () {
      this.$confirm('确定要全部已读吗',  {
        confirmButtonText: '确定',
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: '取消',
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const { data: res } = await this.$http.post('cms/inBox/readAll', {});
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.message
          })
        } else {
          this.$message({
            type: 'warning',
            message: res.message
          })
        }
        this.getMessageCount();
        this.getMessageList();
        this.btnReadFlag = 0;
      })
    },
    reply (row) {     //回复
      this.replyMessageInfo = row;
      this.id = row.id
      this.isVisiable = true
    },
    async onConfirmMsg () {
      this.isVisiable = false
      if (this.detailFlag) {
        const { data: res } = await this.$http.get('cmUser/message/queryMessageInfo/' + this.id);
        this.historyMessageList = res.data
        let arr = []
        res.data.forEach(item => {
          if (item.id == this.id) {
            arr.push(item)
          }
        })
        this.firstList = arr
      }
      this.getMessageCount();
      this.getMessageList()

    },
    replyDialogClose () {    //关闭回复弹窗
      this.replyDialogVisible = false;
    },
    toOrderDetail (row) {
      if (row.orderId.indexOf('P') != -1) { //P出现
        this.$router.push({     //装箱单
          name: 'container',
          query: {
            containerBatchNo: row.orderId
          }
        })
      } else {                  //订单详情
        this.$router.push({
          name: 'orderDetail',
          query: {
            id: row.orderId,
            isEdit: '0'
          }
        })
      }
    }
  },
  watch: {
    //监听时间选择器绑定值变化
    // dateRangeValue() {
    //   //解决时间选择器清空后 绑定值为null问题
    //   if (!this.dateRangeValue) {
    //     this.dateRangeValue = [];
    //     this.queryInfo.createTimeStart = '';
    //     this.queryInfo.createTimeEnd = '';
    //   } else {
    //     if (this.dateRangeValue.length > 0) {
    //       this.queryInfo.createTimeStart = this.dateRangeValue[0];
    //       this.queryInfo.createTimeEnd = this.dateRangeValue[1];
    //     }
    //   }
    //
    // }
  },
  created () {
    this.getMessageCount();
    this.getMessageList();
  }
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.hide /deep/ .el-upload--picture-card {
  display: none;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
.title {
  font-weight: bold;
  font-size: 18px;
  text-align: left;
  margin: 15px 0;
}
.upload-container .editor-slide-upload {
  margin-bottom: 20px;
}
.search-btn-container-status {
  text-align: left !important;
}
.more-image{
  margin: 5px;
}
</style>
